/**
 * TanStack Query hooks for `report-access-by-level-own-team-all-team-per-role`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	reportAccessByLevelOwnTeamAllTeamPerRoleQueryKeys,
	type CreateReportAccessByLevelOwnTeamAllTeamPerRoleBody,
	type ListReportAccessByLevelOwnTeamAllTeamPerRoleResponse,
	type ReportAccessByLevelOwnTeamAllTeamPerRoleRow,
} from "./api";

export function useReportAccessByLevelOwnTeamAllTeamPerRoleList(): UseQueryResult<ListReportAccessByLevelOwnTeamAllTeamPerRoleResponse, Error> {
	return useQuery({
		queryKey: reportAccessByLevelOwnTeamAllTeamPerRoleQueryKeys.list(),
		queryFn: list,
	});
}

export function useReportAccessByLevelOwnTeamAllTeamPerRoleCreate(): UseMutationResult<ReportAccessByLevelOwnTeamAllTeamPerRoleRow, Error, CreateReportAccessByLevelOwnTeamAllTeamPerRoleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: reportAccessByLevelOwnTeamAllTeamPerRoleQueryKeys.all });
		},
	});
}

export function useReportAccessByLevelOwnTeamAllTeamPerRoleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: reportAccessByLevelOwnTeamAllTeamPerRoleQueryKeys.all });
		},
	});
}
